export default __webpack_public_path__ + "static/media/subcategory.9e5fc898.svg";